@if (this.clientData?.result$ | async; as result) {
    @if (result.value?.data; as clientData) {
        @if (result.isLoading) {
            <cll-spinner />
        }

        @if (result.error; as error) {
            <app-error-panel [error]="error" />
        }
        <div class="accordion-container">
            <cll-card-divider />

            <div class="accordion-row-field">
                <app-accordion-item [label]="'Additional comments'" [data]="clientData.person.additional_comments" [showLabel]="false" />
            </div>

            <cll-card-footer>
                <button cll-tonal-button (click)="editAdditionalComments()">
                    <cll-icon cllButtonIcon type="outlined" [size]="20">edit</cll-icon>
                    Edit
                </button>
            </cll-card-footer>
        </div>
    }
}
